import React, {useEffect, useState} from "react";
import style from '../Login.scss';
import {logout} from "@/util/authentication";
import {useHistory} from "react-router";
import RegisterLayout from "@/layout/RegisterLayout";
import MButton from "@/components/atom/MButton";
import {Logo} from "@/components/atom/Logo";
import {resetPasswordRequest} from "@/api";

const ForgotPassword = () => {
  const history = useHistory()
  const [mail, setMail] = useState('')
  const [send, setSend] = useState(false)

  useEffect(() => {
    logout()
  }, [])

  const toLogin = () => {
    history.push('/login')
  }

  const canLogin = () => {
    return mail !== ''
  }

  const doPasswordReset = async () => {
    await resetPasswordRequest({mail})
    setSend(true)
  }

  return (
    <div className="App">
      <RegisterLayout category={''}>
        <div className={style.loginTop}>
          <div className={style.contents}>
            <div>
              <div className={`${style.mainTitle} ${style.titleLogoBlock}`}>
                <Logo/>
              </div>
              { !send &&
                <div className={style.loginForm}>
                  <div className={style.loginTitleLine}>
                    名刺Rに登録しているメールアドレスを入力してください。
                  </div>
                  <div className={style.loginTitleLine}>
                    <span className={style.loginTitle}>メールアドレス</span>
                    <input type="text" value={mail} onChange={(e) => setMail(e.target.value)}/>
                  </div>
                  <div>
                    <MButton value={'送信'} onClick={doPasswordReset} disabled={!canLogin()}></MButton>
                  </div>
                </div>
              }
              { send &&
                <div className={style.loginForm}>
                  <div className={style.loginTitleLine}>
                    パスワード再設定メールを送信しました。
                  </div>
                </div>
              }
              <div className={style.passwordInformation}>
                <span onClick={toLogin} className={style.link}>ログイン</span>画面へ
              </div>
            </div>
          </div>
        </div>
      </RegisterLayout>
    </div>
  )
}

export default ForgotPassword;
